import { BaseService } from "./baseService";

export interface AnalyticsEvent {
  eventType: string;
  pagePath?: string;
  referrer?: string;
  sessionId: string;
  userId?: string | null;
  [key: string]: any;
}

export class AnalyticsService extends BaseService {
  private static sessionId: string | null = null;
  private static userId: string | null = null;

  private static generateSessionId(): string {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  private static getSessionId(): string {
    if (!this.sessionId) {
      this.sessionId = this.generateSessionId();
    }
    return this.sessionId;
  }

  public static setUserId(userId: string | null): void {
    this.userId = userId;
  }

  public static async trackPageView(customPath?: string): Promise<void> {
    if (typeof window === 'undefined') return;

    const pagePath = customPath || window.location.pathname;

    await this.trackEvent('page_view', {
      pagePath,
      referrer: document.referrer || null,
    });
  }

  public static async trackEvent(eventType: string, data: Record<string, any> = {}): Promise<void> {
    try {
      const payload: AnalyticsEvent = {
        eventType,
        pagePath: data.pagePath || (typeof window !== 'undefined' ? window.location.pathname : ''),
        referrer: data.referrer || (typeof window !== 'undefined' ? document.referrer : null) || null,
        sessionId: this.getSessionId(),
        userId: this.userId,
        ...data
      };

      const response = await this.post('/analytics/track', payload);

      if (!response.ok) {
        console.warn('Analytics tracking failed:', response.status, response.statusText);
      }
    } catch (error) {
      console.warn('Analytics tracking failed:', error);
    }
  }

  public static async trackCustomEvent(eventType: string, properties: Record<string, any> = {}): Promise<void> {
    await this.trackEvent(eventType, properties);
  }
}
